var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpeed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3709_31742)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.2588 11.8185C19.276 10.7699 19.0911 9.73153 18.7148 8.76269C18.3384 7.79385 17.7779 6.9136 17.0653 6.17209C16.3527 5.43059 15.5018 4.84239 14.5614 4.4411C13.621 4.0398 12.6095 3.83325 11.5845 3.83325C10.5595 3.83325 9.54123 4.0398 8.58765 4.4411C7.6341 4.84239 6.76402 5.43059 6.02709 6.17209C5.29015 6.9136 4.70079 7.79385 4.29267 8.76269C3.88454 9.73153 3.66563 10.7699 3.64844 11.8185H6.38025C6.39142 11.1369 6.53372 10.462 6.799 9.83227C7.06428 9.20253 7.44737 8.63036 7.9264 8.14836C8.40541 7.66638 8.97091 7.28405 9.59076 7.02321C10.2105 6.76236 10.8725 6.6281 11.5387 6.6281C12.2049 6.6281 12.8625 6.76236 13.4737 7.02321C14.085 7.28405 14.638 7.66638 15.1012 8.14836C15.5644 8.63036 15.9287 9.20253 16.1734 9.83227C16.418 10.462 16.5381 11.1369 16.527 11.8185H19.2588Z",
    fill: "url(#paint0_linear_3709_31742)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.26575 11.4999C1.26575 17.1516 5.84737 21.7333 11.4991 21.7333C17.1508 21.7333 21.7324 17.1516 21.7324 11.4999C21.7324 5.84822 17.1508 1.2666 11.4991 1.2666C5.84737 1.2666 1.26575 5.84822 1.26575 11.4999Z",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4992 19.55C15.9451 19.55 19.5492 15.9458 19.5492 11.5C19.5492 7.05406 15.9451 3.44995 11.4992 3.44995C7.05333 3.44995 3.44922 7.05406 3.44922 11.5C3.44922 15.9458 7.05333 19.55 11.4992 19.55Z",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8 9.19995L11.5 13.8",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8415 13.7999C12.8415 14.5409 12.2409 15.1416 11.4999 15.1416C10.7589 15.1416 10.1582 14.5409 10.1582 13.7999C10.1582 13.0589 10.7589 12.4583 11.4999 12.4583C12.2409 12.4583 12.8415 13.0589 12.8415 13.7999Z",
    fill: "#00A651",
    stroke: "white",
    strokeWidth: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3709_31742",
    x1: 3.45029,
    y1: 11.8833,
    x2: 19.546,
    y2: 11.6194,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A651"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.469,
    stopColor: "#CACA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D62828"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3709_31742"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeed);
export default __webpack_public_path__ + "static/media/speed.d12f15ea8e84a5d2f238b12c525b771e.svg";
export { ForwardRef as ReactComponent };